import React, { useState } from 'react';
import { Nav } from 'reactstrap';
import MenuItem from './menu_item';
import BrandDropdown from '../nav_bar/brand_dropdown';
import MenuLanguage from './menu_language';
import ImportData from '../import_data';
import { getMenu } from './services';
import { PrivateComponent } from '../permissions';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { getFeatures } from '../../redux/app/appActions';
import { TMenuItem } from './menu_item/types';
import './Menu.scss';

const Menu: React.FC = () => {
  const features = useSelector(getFeatures);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleSidebar = () => {
    document.body.classList.toggle('nav-open');
  };

  return (
    <div className="sidebar-root">
      <i
        role="button"
        tabIndex={0}
        aria-label="bullet list"
        className={classNames(
          'tim-icons icon-bullet-list-67',
          'bullet-list',
          'bullet-list-open'
        )}
        onClick={toggleSidebar}
        onKeyDown={toggleSidebar}
      />
      <div className={classNames('sidebar', 'sidebar-ext')}>
        <div className={classNames('sidebar-wrapper', 'vrr-background')}>
          <div>
            <BrandDropdown />
            {getMenu(setIsModalOpen, features).map(
              (item: TMenuItem, index: number) => (
                <Nav key={item.mainRoute.name ?? index.toString()}>
                  <PrivateComponent requires={item.requires}>
                    <MenuItem
                      id={item.id || index.toString()}
                      mainRoute={item.mainRoute}
                      subRoutes={item.subRoutes}
                    />
                  </PrivateComponent>
                </Nav>
              )
            )}
            <ImportData
              isOpen={isModalOpen}
              onCancelAction={() => setIsModalOpen(false)}
            />
          </div>
          <MenuLanguage />
        </div>
      </div>
    </div>
  );
};

export default Menu;
